module.exports = __webpack_public_path__ + "img/ajax-loader.278158c.gif";